"use client";

import {
  Image,
  ImageField,
  withDatasourceCheck,
  LinkField,
  useSitecoreContext,
} from "@sitecore-jss/sitecore-jss-nextjs";
import clsx from "clsx";
import Link from "next/link";
import { ComponentProps } from "@repo/sitecore-lib/component-props";
import styles from "./image-link.module.css";

export type ImageLinkType = {
  fields: {
    image: ImageField;
    link: LinkField;
  };
};

export type ImageLinkProps = ComponentProps &
  ImageLinkType & {
    classname?: string;
  };

const ImageLink = ({
  fields,
  classname,
}: ImageLinkProps): JSX.Element | null => {
  const { sitecoreContext } = useSitecoreContext();
  const isEditing = sitecoreContext?.pageEditing;

  if (!fields.link?.value?.href || !fields.image?.value?.src) {
    if (!isEditing) {
      if (!fields.image?.value?.src) {
        return <></>;
      } else {
        return (
          <Image
            field={fields.image}
            data-testid="next-image"
            className={styles["image-not-link"]}
          />
        );
      }
    }
  }
  return (
    <Link
      href={fields.link.value.href as string}
      target={fields.link.value.target as string}
      aria-label={(fields.image.value?.alt as string) || undefined}
      aria-describedby={(fields.image.value?.alt as string) || undefined}
      className={clsx(classname && styles[classname])}
    >
      <Image field={fields.image} data-testid="next-image" editable />
    </Link>
  );
};

export default withDatasourceCheck()<ImageLinkProps>(ImageLink);
